module.exports = __webpack_public_path__ + "img/renyiApp.66ebd5a6.png";